import {ApiStore as DRFApiStore} from 'lib/api/django-restframework/api-store';
import URL from 'url-parse';

export class ApiStore extends DRFApiStore {
    processJSONArray(options) {
        const {json, response} = options;

        if (response) {
            const count = response.headers['x-wp-total'];
            const pages = response.headers['x-wp-totalpages'];

            if (count != null && pages != null) {
                const href = response.href;

                const url = new URL(href, ' ', true);

                let page = parseInt(url.query.page, 10);
                if (isNaN(page)) {
                    page = 1;
                }

                let previous;
                let next;

                if (page !== 1) {
                    previous = new URL(href, ' ', true);
                    previous.set('query', {
                        ...previous.query,
                        page: page - 1,
                    });
                }

                if (page < pages) {
                    next = new URL(href, ' ', true);
                    next.set('query', {
                        ...next.query,
                        page: page + 1,
                    });
                }
                const result = {
                    count,
                    results: json,
                    next: (next && next.href) || null,
                    previous: (previous && previous.href) || null,
                };

                return this.processPagedJSON({...options, json: result});
            }
        }

        return this.processPlainJSONArray(options);
    }
}
